module.exports = __webpack_public_path__ + "a9474a204af99bf5449e575d46ff02b7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./illustration.png
 ** module id = 386
 ** module chunks = 0
 **/